/* eslint-disable no-console */
import { ChildrenPropType } from '../../services/proptypes';
import './RecaptchaProvider.css';
var propTypes = {
  children: ChildrenPropType.isRequired
};
var defaultProps = {};
export default function RecaptchaProvider(_ref) {
  var children = _ref.children;
  // ReCaptcha logic was moved to useRecaptcha hook
  return children;
}
RecaptchaProvider.propTypes = propTypes;
RecaptchaProvider.defaultProps = defaultProps;